export const ssrConfig = ():
	| {
			doneAsFmp: boolean;
	  }
	| undefined => (window.__SSR_RENDERED__ ? { doneAsFmp: true } : undefined);
